import store from "../../redux/store";
import { getCookie, checkLocalStorage } from "../cookies";
import { consentData } from './set_consent_data';

/**
 * @param  {} period=1000*10
 */

const checkConsentExpireTime = (period = store.getState().expireTimeOneNegative) => {
    
    // checks if cookie is set because new ConsentData() without cookie value resets the lastUpdated on initialisation
    if (!getCookie() || !checkLocalStorage()) { return true }

    const now = new Date();
    const lastUpdateDate = consentData.getLastUpdated();

    if (now.getTime() > (lastUpdateDate.getTime() + period)) {
        consentData.setLastUpdated();
        return true;
    }

    return false;
};

export default checkConsentExpireTime;